import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-26" data-mp="2vcia0511fz82">
      {label && <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-27" data-mp="2vb76857lergy">
          {label}
        </label>}
      <input className={`w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${error ? 'border-red-400' : ''} ${className}`} {...props} data-id="element-28" data-mp="2mclqsixf3ske" />
      {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-29" data-mp="27fkwq8rr7lir">{error}</p>}
    </div>;
}